export class CameraImage {
  constructor(id, original, prediction, type, date, cameraId, label, { rb, clr }) {
    /** @type {number} */
    this.id = id;

    /** @type {string} */
    this.name = this.#parseName(original);

    /** @type {string} */
    this.original = original;

    /** @type {string} */
    this.prediction = prediction;

    /** @type {Date} */
    this.date = date;

    /** @type {string} */
    this.rb = rb;

    /** @type {string} */
    this.clr = clr;

    /** @type {string} */
    this.cameraId = cameraId;

    /** @type {string} */
    this.label = label;

    /** @type {string} */
    this.type = type;
  }

  // @ts-ignore
  #parseName = (url) => new URL(url).pathname.split("/").pop();

  static fromApi = CameraImageMapper;
}

function CameraImageMapper(
  {
    _id,
    id,
    s3_key,
    label: prediction,
    s3_key_explanation_colored,
    s3_key_explanation_redblue,
    created_at,
    camera_id,
    actions,
    label,
    type,
  },
  index
) {
  if (!_id) _id = id;
  return new CameraImage(
    _id,
    s3_key,
    prediction,
    type,
    new Date(actions?.producer_time_fragment ?? created_at),
    camera_id,
    label,
    {
      rb: s3_key_explanation_redblue,
      clr: s3_key_explanation_colored,
    }
  );
}
